<template>
  <div :class="`variants-card ${variant}`">
    <div v-if="getFullMode" class="flex">
      <div class="w-3/5">
        <div class="flex items-center justify-between">
          <div>
            <span v-html="htmlTitle" />
          </div>
        </div>

        <time class="text-xs text-gray-600">
          <i class="fa fa-clock-o mr-1" />
          <span>{{ time }}</span>
        </time>
      </div>
      <div class="w-2/5">
        <div class="flex justify-around ">
          <!-- trip others info -->
          <div v-if="timelineType === 'trip'" class="text-center">
            <BatteryStatus :level="getPowerLevel(log)" />
          </div>
          <div v-if="timelineType === 'trip'" class="text-center">
            <div class="map-icon-wrapper">
              <div
                class="map-icon"
                @click="$emit('click-map', log.location_coord)"
              >
                <i class="fas fa-map" />
              </div>
            </div>
          </div>
          <div v-if="timelineType === 'trip'" class="text-center">
            {{ getUserBalance(log) }}
          </div>

          <!-- rental others info -->
          <div v-if="timelineType === 'rental'" class="text-center">
            <BatteryStatus :level="getPowerLevel(log)" />
          </div>
          <div v-if="timelineType === 'rental'" class="text-center">
            <div class="map-icon-wrapper">
              <div
                class="map-icon"
                @click="$emit('click-map', log.location_coord)"
              >
                <i class="fas fa-map" />
              </div>
            </div>
          </div>
          <div v-if="timelineType === 'rental'" class="text-center">
            {{ getUserBalance(log) }}
          </div>

          <!-- vehicle others info -->
          <div v-if="timelineType === 'vehicle'" class="text-center">
            <BatteryStatus :level="getPowerLevel(log)" />
          </div>
          <div v-if="timelineType === 'vehicle'" class="text-center">
            <div class="map-icon-wrapper">
              <div
                class="map-icon"
                @click="$emit('click-map', log.location_coord)"
              >
                <i class="fas fa-map" />
              </div>
            </div>
          </div>
          <div v-if="timelineType === 'vehicle'" class="text-center">
            <RouterLink
              v-if="actor"
              :to="{
                name: `${
                  actor.role_name == '--'
                    ? 'ViewRiderUserProfile'
                    : 'ViewOrganizationUserProfile'
                }`,
                params: { id: actor.id },
              }"
              target="_blank"
              class="text-blue-600 capitalize"
            >
              {{ actor.full_name }}
            </RouterLink>
            <span v-if="actor" class="text-sm text-gray-600">
              ({{ actor.role_name }})
            </span>
            <span v-if="!actor" class="">--</span>
          </div>

          <!-- rider others info -->
          <div v-if="timelineType === 'rider'" class="text-center">
            {{ getRiderBalanceStr }}
          </div>
          <div v-if="timelineType === 'rider'" class="text-center">
            <div class="map-icon-wrapper">
              <div
                class="map-icon"
                @click="$emit('click-map', log.location_coord)"
              >
                <i class="fas fa-map" />
              </div>
            </div>
          </div>
          <div v-if="timelineType === 'rider'" class="text-center">
            <RouterLink
              v-if="tripId !== ''"
              :to="{
                name: 'ViewTrip',
                params: { id: tripId },
              }"
              target="_blank"
              class="text-blue-600 capitalize"
            >
              #{{ tripId.substr(tripId.length - 5) }}
            </RouterLink>
            <span v-if="tripId === ''" class="">--</span>
          </div>
          <!-- put others timelineType info -write from here -->
        </div>
      </div>
    </div>
    <div v-if="getResponsiveMode">
      <div class="w-full">
        <div class="flex items-center justify-between">
          <div>
            <span v-html="htmlTitle" />
          </div>
        </div>

        <time class="text-xs text-gray-600">
          <i class="fa fa-clock-o mr-1" />
          <span>{{ time }}</span>
        </time>
      </div>

      <!-- trip others info -->
      <div
        class="grid grid-cols-12  w-full py-1"
        v-if="timelineType === 'trip'"
      >
        <div class="col-span-5 ">Battery</div>
        <div class="col-span-7">
          <div>
            <BatteryStatus :level="getPowerLevel(log)" />
          </div>
        </div>
      </div>
      <div class="grid grid-cols-12 w-full py-1" v-if="timelineType === 'trip'">
        <div class="col-span-5">Location</div>
        <div class="col-span-7">
          <div>
            <div class="map-icon-wrapper">
              <div
                class="map-icon"
                @click="$emit('click-map', log.location_coord)"
              >
                <i class="fas fa-map" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="grid grid-cols-12  w-full py-1"
        v-if="timelineType === 'trip'"
      >
        <div class="col-span-5 ">Balance</div>
        <div class="col-span-7">
          <div>
            {{ getUserBalance(log) }}
          </div>
        </div>
      </div>

      <!-- rental others info -->
      <div
        class="grid grid-cols-12  w-full py-1"
        v-if="timelineType === 'rental'"
      >
        <div class="col-span-5 ">Battery</div>
        <div class="col-span-7">
          <div>
            <BatteryStatus :level="getPowerLevel(log)" />
          </div>
        </div>
      </div>
      <div
        class="grid grid-cols-12 w-full py-1"
        v-if="timelineType === 'rental'"
      >
        <div class="col-span-5">Location</div>
        <div class="col-span-7">
          <div>
            <div class="map-icon-wrapper">
              <div
                class="map-icon"
                @click="$emit('click-map', log.location_coord)"
              >
                <i class="fas fa-map" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="grid grid-cols-12  w-full py-1"
        v-if="timelineType === 'rental'"
      >
        <div class="col-span-5 ">Balance</div>
        <div class="col-span-7">
          <div>
            {{ getUserBalance(log) }}
          </div>
        </div>
      </div>
      <!-- vehicle others info -->
      <div
        class="grid grid-cols-12  w-full py-1"
        v-if="timelineType === 'vehicle'"
      >
        <div class="col-span-5 ">Battery</div>
        <div class="col-span-7">
          <div>
            <BatteryStatus :level="getPowerLevel(log)" />
          </div>
        </div>
      </div>
      <div
        class="grid grid-cols-12 w-full py-1"
        v-if="timelineType === 'vehicle'"
      >
        <div class="col-span-5">Location</div>
        <div class="col-span-7">
          <div>
            <div class="map-icon-wrapper">
              <div
                class="map-icon"
                @click="$emit('click-map', log.location_coord)"
              >
                <i class="fas fa-map" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="grid grid-cols-12 w-full py-1"
        v-if="timelineType === 'vehicle'"
      >
        <div class="col-span-5">Actor</div>
        <div class="col-span-7">
          <RouterLink
            v-if="actor"
            :to="{
              name: 'ViewOrganizationUserProfile',
              params: { id: actor.id },
            }"
            target="_blank"
            class="text-blue-600 capitalize"
          >
            {{ actor.full_name }}
          </RouterLink>
          <span v-if="actor" class="text-sm text-gray-600">
            ({{ actor.role_name }})
          </span>
          <span v-if="!actor" class="">--</span>
        </div>
      </div>

      <!-- rider others info -->
      <div
        class="grid grid-cols-12  w-full py-1"
        v-if="timelineType === 'rider'"
      >
        <div class="col-span-5 ">Battery</div>
        <div class="col-span-7">
          {{ getRiderBalanceStr }}
        </div>
      </div>

      <div
        class="grid grid-cols-12 w-full py-1"
        v-if="timelineType === 'rider'"
      >
        <div class="col-span-5">Location</div>
        <div class="col-span-7">
          <div>
            <div class="map-icon-wrapper">
              <div
                class="map-icon"
                @click="$emit('click-map', log.location_coord)"
              >
                <i class="fas fa-map" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="grid grid-cols-12 w-full py-1"
        v-if="timelineType === 'rider'"
      >
        <div class="col-span-5">Trip Id</div>
        <div class="col-span-7">
          <RouterLink
            v-if="tripId !== ''"
            :to="{
              name: 'ViewTrip',
              params: { id: tripId },
            }"
            target="_blank"
            class="text-blue-600 capitalize"
          >
            #{{ tripId.substr(tripId.length - 5) }}
          </RouterLink>
          <span v-if="tripId === ''" class="">--</span>
        </div>
      </div>
      <!-- put others timelineType info  -write from here -->
    </div>

    <slot name="contextData">
      <TimelineLogLayerDetailsContext :context="context" />
    </slot>

    <slot
      name="expandable"
      v-bind="{ expandableSlotClass: getClassFor('expandableSlot') }"
    >
      <div
        v-if="iotCmdReqId && actionType"
        :class="getClassForIOT('expandableSlot')"
      >
        <!-- toggle -->
        <slot name="iotToggle">
          <button
            v-if="iotCmdReqId && actionType"
            :class="getClassForIOT('iotToggle')"
            @click="toggleExpandable('iot')"
          >
            {{ isExpanded('iot') ? 'Hide' : 'Show' }}

            IOT Log

            <svg
              width="17"
              height="8"
              viewBox="0 0 17 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.3536 4.35355C16.5488 4.15829 16.5488 3.84171 16.3536 3.64645L13.1716 0.464466C12.9763 0.269204 12.6597 0.269204 12.4645 0.464466C12.2692 0.659728 12.2692 0.976311 12.4645 1.17157L15.2929 4L12.4645 6.82843C12.2692 7.02369 12.2692 7.34027 12.4645 7.53553C12.6597 7.7308 12.9763 7.7308 13.1716 7.53553L16.3536 4.35355ZM0 4.5H16V3.5H0V4.5Z"
                fill="#0954E4"
              />
            </svg>
            <loading
              :height="25"
              color="#1F2937"
              :active="isIOTLogLoading"
              loader="bars"
              :class="`outline-none`"
              :is-full-page="false"
            />
          </button>

          <span
            v-else
            v-text="`No request trace!`"
            class="text-sm text-gray-500"
          />
        </slot>
        <!-- /toggle -->

        <!-- logsContent -->
        <slot name="logsContent">
          <AccordionTransition :expanded="isExpanded('iot')">
            <div class="max-w-2xl">
              <pre
                class="
                  log-code
                  flex flex-col
                  min-h-full
                  font-mono
                  text-xs text-gray-100
                  bg-black
                  md:text-sm
                "
                v-html="iotData"
              ></pre>
            </div>
          </AccordionTransition>
        </slot>
        <!-- logsContent -->
      </div>
    </slot>
  </div>
</template>
<script>
import { useEndpoints } from '@/composables'
import { get as propertyValue } from 'lodash-es'
export default {
  components: {
    BatteryStatus: () => import('@/components/badge/BatteryStatus.vue'),
    AccordionTransition: () =>
      import('@/components/accordion/AccordionTransition.vue'),
    TimelineLogLayerDetailsContext: () =>
      import('./TimelineLogLayerDetailsContext.vue'),
  },

  props: {
    timelineType: {
      type: String,
      required: false,
      default: 'generic',
    },
    log: {
      type: Object,
    },
    htmlTitle: {
      type: String,
      default: '',
    },

    time: {
      type: String,
      default: '',
    },
    requestTraceId: {
      type: String,
      default: '',
    },
    iotCmdReqId: {
      type: String,
      default: '',
    },
    actionType: {
      type: String,
      default: '',
    },
    actor: {
      type: Object,
      default: null,
    },
    userBalance: {
      type: [String, Number],
      default: '0.0',
    },
    userBalanceCurrency: {
      type: String,
      default: '$',
    },
    tripId: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: 'light',
    },

    context: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      expandables: {
        logs: false,
        iot: false,
      },
      requestTrace: '',
      iotData: '',
      isLogLoading: false,
      isIOTLogLoading: false,
    }
  },
  computed: {
    getFullMode() {
      return window.matchMedia('(min-width: 931px)').matches
    },
    getResponsiveMode() {
      return window.matchMedia('(max-width: 930px)').matches
    },
    getRiderBalanceStr() {
      return `${this.userBalanceCurrency} ${this.userBalance}`
    },
  },

  methods: {
    getUserBalanceCurrency(log) {
      const prefCurrency = propertyValue(log, 'preferred_currency.symbol')

      if (prefCurrency) {
        return prefCurrency
      }

      if (log.user_currency_symbol) {
        return log.user_currency_symbol
      }

      const fdCurrency = propertyValue(
        log,
        'extra_data.user_data.profile_data.current_fleet.currency.symbol'
      )

      if (fdCurrency) {
        return fdCurrency
      }

      const orgInfo = this.$store.getters['auth/organizationInfo']
      return orgInfo ? orgInfo.default_currency.symbol : undefined
    },
    getUserBalance(log) {
      const conversionRate = propertyValue(log, 'conversion_rate')

      let balance = 0.0

      if (log.user_balance) {
        balance = parseFloat(log.user_balance)
      } else {
        const pdBalance = propertyValue(
          log,
          'extra_data.user_data.profile_data.balance'
        )

        if (pdBalance) {
          balance = parseFloat(pdBalance)
        }
      }

      return typeof balance === 'number'
        ? `${this.getUserBalanceCurrency(log)} ${(
            balance * (conversionRate || 1)
          ).toFixed(2)}`
        : '--'
    },
    getPowerLevel(log) {
      // console.log(log?.extra_data?.vehicle_data?.lock_data, 'poe')
      const p = parseInt(log?.extra_data?.vehicle_data?.lock_data?.power_level)
      return typeof p === 'number' && !isNaN(p) ? p : 0
    },
    getClassFor(term = '') {
      const map = {
        expandableSlot: `mt-2 relative`,
        logsToggle: 'flex items-center text-blue-600 gap-2 text-sm',
      }

      return map[term] || `no-class-found-for:${term}`
    },
    getClassForIOT(term = '') {
      const map = {
        expandableSlot: `mt-2 relative`,
        iotToggle: 'flex items-center text-blue-600 gap-2 text-sm',
      }

      return map[term] || `no-class-found-for:${term}`
    },
    isExpanded(term) {
      return this.expandables[term]
    },
    toJSONSafe(rawData) {
      try {
        return JSON.parse(rawData)
      } catch {
        return rawData
      }
    },
    async toggleExpandable(term) {
      this.expandables[term] = !this.expandables[term]

      if (this.expandables['logs']) {
        this.isLogLoading = true
        const url = useEndpoints.trip.requestLog(this.requestTraceId)
        await this.$http
          .get(url)
          .then((res) => {
            console.log('fetchReqLogs res = ', res)
            const trace = res.data
            if (!trace) {
              this.requestTrace = ''
            } else {
              const reqTitle =
                '<div>Request Logs</div><div>==============</div>'
              const resTitle =
                '<br/><br/><div>Response Logs</div><div>==============</div>'

              const reqLogs = {
                id: trace?.id,
                ip: trace?.ip,
                user_agent: trace?.user_agent,
                host: trace?.host,
                method: trace?.method,
                path: trace?.path,
                request_body: this.toJSONSafe(trace?.request_body),
              }

              let response = trace?.response
              const resLogs = {
                language: trace?.language,
                response_code: trace?.response_code,
                response_time: trace?.exec_time,
                response_body: this.toJSONSafe(response),
              }
              this.requestTrace = `<span class="block overflow-auto">${reqTitle}${JSON.stringify(
                reqLogs,
                null,
                4
              )}<br/>${resTitle}${JSON.stringify(resLogs, null, 4)}</span>`
            }
          })
          .catch((err) => {
            // console.error('fetchReqLogs err = ', err, err.response.data)
            console.error('fetchReqLogs err = ', { err })
          })
          .finally(() => (this.isLogLoading = false))
      }
      if (this.expandables['iot']) {
        this.isIOTLogLoading = true
        const url = useEndpoints.trip.iotLog(this.iotCmdReqId, this.actionType)
        await this.$http
          .get(url)
          .then((res) => {
            console.log('fetchReqLogs res = ', res)
            const reqTitle = '<div>Request Logs</div><div>==============</div>'
            const resTitle =
              '<br/><br/><div>Response Logs</div><div>==============</div>'
            const iotLogs = res.data

            let parsed_data = iotLogs?.data?.parsed_data
            if (typeof parsed_data == 'string') {
              let back_slash = '\\'
              parsed_data = parsed_data.replace(`/${back_slash}/g`, '')
              iotLogs.data.parsed_data = JSON.parse(parsed_data)
            }
            this.iotData = `${
              iotLogs.data_type === 'response' ? resTitle : reqTitle
            }<span class="block overflow-auto">${JSON.stringify(
              iotLogs.data,
              null,
              4
            )}</span>`
          })
          .catch((err) => {
            // console.error('fetchReqLogs err = ', err, err.response.data)
            console.error('fetchReqLogs err = ', { err })
          })
          .finally(() => (this.isIOTLogLoading = false))
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.variants-card {
  @apply p-4 mt-3;
  border-radius: 7px;

  &.light {
    background: #fff;
    border: 1px solid #d5d5d5;
    border-radius: 8px;
  }

  &.secondary {
    background: #f1f1f1;
    border: 1px solid #d5d5d5;
    border-radius: 8px;
    max-width: 100%;
  }

  &.warning {
    background: #f9f0d7;
    border: 1px solid #f2c816;
    border-radius: 8px;
  }
}
.logs-content {
  color: #fff;
  padding: 5px 8px;
  background: #000000;
  border: 1px solid #ffffff;
  border-radius: 7px;
  overflow: auto !important;
}
.map-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: normal;
  text-align: center;
  color: #ffffff;
  border-radius: 5px;
  background-color: #ff598a;
  cursor: pointer;
  width: 23px;
  height: 23px;
  background-color: #12ceda;
}
</style>
